export const WIDTH_XS_MOBILE = 360
export const WIDTH_MOBILE = 412
export const WIDTH_L_MOBILE = 600
export const HEIGHT_XS_MOBILE = 800
export const HEIGHT_MOBILE = 915
export const RRSS = {
  instagram: 'https://www.instagram.com/gastandorollos/',
  tiktok: ''
}
